const Data = {
  productItems: [
    {
      id: 1,
      discount: 10,
      cover: "./images/flash/z590.png",
      name: "GigaByte Z590",
      price: 250,
    },
    {
      id: 2,
      discount: 25,
      cover: "./images/flash/monitorA.png",
      name: "Monitor Aorus 24.5 240hz",
      price: 600,
    },
    {
      id: 3,
      discount: 25,
      cover: "./images/flash/aorusN.png",
      name: "Notebook Gigabyte Aorus 17 - i7 10700K-3070TI ",
      price: 1000,
    },
    {
      id: 4,
      discount: 10,
      cover: "./images/flash/Asus3080.jpg",
      name: "ROG STRIX RTX 3060 TI O12G GAMING",
      price: 450,
    },
    {
      id: 5,
      discount: 20,
      cover: "./images/flash/i5.jpg",
      name: "i5-11400F Six Core 2.6GHz",
      price: 250,
    },
    {
      id: 6,
      discount: 20,
      cover: "./images/flash/logi733.png",
      name: "logitech g733 rgb lightsync",
      price: 50,
    },
  ],
};
export default Data;
